<template>
  <div>
    <div class="process-list">
      <div
        v-ripple
        v-for="process in filteredFolderProcesses"
        :key="process.name"
        class="process-item"
        :class="[fontSize,{highlight:(folder && folder.name===process.name)}]"
        @click="openFolder(process, process.name)"
      >
        <p v-if="xs">{{ bottomProccessesObject[process.name].xs ? bottomProccessesObject[process.name].xs : process.name }}</p>
        <p v-else-if="sm">{{ bottomProccessesObject[process.name].sm ? bottomProccessesObject[process.name].sm : process.name }}</p>
        <p v-else-if="md">{{ bottomProccessesObject[process.name].md ? bottomProccessesObject[process.name].md : process.name }}</p>
        <p v-else>{{ process.name }}</p>
      </div>
    </div>
    <div v-ripple class="process" @click="openFolder(parentProcessObject, elements.process)"
    :class="{ 'highlight': selectedElement === elements.process }">
      <p class="ma-0">{{ parentProcess.toUpperCase() }}</p>
    </div>
  </div>
</template>

<script>
import common from "@/mixins/common";
import {mapState} from "vuex";

export default {
  name: "MapBottom",
  mixins: [common],
  data() {
    return {
      selectedElement: null,
      elements: {
        process: 'process'
      },
      parentProcess: 'Supportprozesse',
      parentProcessObject: {},
      bottomProcessesArray: ['IT', 'Gebäude- und Haltestellen-Infrastruktur', 'Personaladministration', 'Finanzadministration', 'Fahrzeuge', 'Reinigung'],
      bottomProccessesObject: {
        'IT': 'IT',
        'Gebäude- und Haltestellen-Infrastruktur': 'Gebäude- und Haltestellen-Infrastruktur',
        'Personaladministration': {xs: 'Personal-admini-stration', sm: 'Personaladmini-stration', md: 'Personaladmini-stration'},
        'Finanzadministration': {xs: 'Finanz-admini-stration', sm: 'Finanzadmini-stration', md: 'Finanzadmini-stration'},
        'Fahrzeuge': 'Fahrzeuge',
        'Reinigung': 'Reinigung',
      },
      filteredFolderProcesses: [],
    }
  },
  mounted() {
  },
  computed: {
    ...mapState('documents', ['dataLoaded', 'documents', 'folders', 'foldersById']),
    fontSize() {
      if (this.xs) {
        return 'xsmall-font-size'
      } else if (this.xl) {
        return ''
      } else {
        return 'small-font-size'
      }
    },
    folderId(){
      return this.$route.params.folderId
    },
    folder(){
      return this.foldersById[this.folderId]
    }
  },
  methods: {
    computeFilteredFolderProcesses() {
      if (this.foldersById && Object.keys(this.foldersById).length > 0) {
        const bottomProcessesArray = Object.keys(this.bottomProccessesObject);
        this.filteredFolderProcesses = [];
        Object.keys(this.foldersById).forEach((key) => {
          const item = this.foldersById[key];
          const itemName = item.name.trim();
          if (bottomProcessesArray.includes(itemName)) {
            this.filteredFolderProcesses.push(item);
          } else if (itemName === this.parentProcess) {
            this.parentProcessObject = item;
          }
        });
      }
    },
    /**
     * Open a folder and navigate to the specified document folder.
     *
     * @param {Object} process - The process object containing instance and folderId
     * @param elementId
     */
    openFolder(process, elementId = null) {
      this.selectedElement = elementId;
      this.mx_isLeftDrawerOpen = true;
      this.$router.push({name: 'documentFolder', params: {instance: process.instance, folderId: process.id}});
    }
  },
  watch: {
    'foldersById': {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.computeFilteredFolderProcesses();
        }
      }
    }
  }
}
</script>

<style scoped>
.process-list {
  display: flex;
  justify-content: space-between;
  gap: 2px;
  clip-path: polygon(50% 0, 100% 25%, 100% 100%, 0 100%, 0 25%);
  width: 100%;
  height: 100px;
}

.process-item {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-color: #999999;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.process-item p {
  margin: 1em 0;
  padding: 0 5px;
  color: #ffffff;
}

.xsmall-font-size p {
  font-size: x-small;
}

.small-font-size p {
  font-size: small;
}

.process {
  background-color: #999999;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  padding:2px 0;
  margin-top:2px
}

.highlight {
  background: none;
  background-color: #005289;
}
</style>